import './main.css';

import './anim.js';

import Alpine from 'alpinejs';
import { clearAllBodyScrollLocks, disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { animate, inView, scroll } from 'motion';

window.Alpine = Alpine;

Alpine.start();

const logoSlider = document.querySelector('.logo-slider');
if (logoSlider) {
  const logoOptions = {
    accessibility: true,
    draggable: true,
    wrapAround: true,
    autoPlay: 5000,
    pauseAutoPlayOnHover: false,
    prevNextButtons: false,
    pageDots: false,
    imagesLoaded: true,
    cellAlign: 'center',
  };

  logoSlide = new Flickity(logoSlider, logoOptions);
}

const init = () => {
  document.addEventListener('scroll:lock', (e) => {
    if (e.detail?.element) {
      disableBodyScroll(e.detail.element);
    }
  });

  document.addEventListener('scroll:unlock', (e) => {
    if (e.detail?.element) {
      enableBodyScroll(e.detail.element);
    } else {
      clearAllBodyScrollLocks();
    }
  });

  // disable scroll when cart is open
  const targetElement = document.querySelector('.js-go-cart-overlay');

  const classChangeCallback = (mutationsList, observer) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        // Check if 'is-open' class is added or removed
        if (targetElement.classList.contains('is-open')) {
          disableBodyScroll(targetElement);
        } else {
          enableBodyScroll(targetElement);
        }
      }
    }
  };

  // Create a MutationObserver instance
  const observer = new MutationObserver(classChangeCallback);
  observer.observe(targetElement, { attributes: true });

  //HALF CAROUSEL SLIDER
  const halfParent = document.querySelectorAll('.half-carousel-wrapper');
  let halfFlkty;

  const updateHalfSliderOptions = () => {
    const isMobile = window.innerWidth < 1024;

    const modifiedOptions = {
      accessibility: false,
      wrapAround: false,
      autoPlay: false,
      prevNextButtons: false,
      cellAlign: isMobile ? 'center' : 'left',
      pageDots: false,
      imagesLoaded: true,
      cellSelector: '.carousel-cell',
    };

    halfParent.forEach((container) => {
      const locationSlider = container.querySelector('.location-slider');
      halfFlkty = new Flickity(locationSlider, modifiedOptions);

      const currentIndex = halfFlkty ? halfFlkty.selectedIndex : 0;

      halfFlkty.select(currentIndex);

      container.querySelector('.half-previous').addEventListener('click', function () {
        halfFlkty.previous();
      });
      container.querySelector('.half-next').addEventListener('click', function () {
        halfFlkty.next();
      });
      container.querySelector('.half-previous-mob').addEventListener('click', function () {
        halfFlkty.previous();
      });
      container.querySelector('.half-next-mob').addEventListener('click', function () {
        halfFlkty.next();
      });
    });
  };

  updateHalfSliderOptions();

  //HALF CAROUSEL SLIDER END

  if (document.querySelector('.main-product-carousel')) {
    var options = {
      accessibility: true,
      prevNextButtons: true,
      pageDots: false,
      imagesLoaded: true,
    };

    var navOptions = {
      asNavFor: '.main-product-carousel',
      draggable: false,
      groupCells: '100%',
      pageDots: false,
      prevNextButtons: false,
    };

    var mainCarousel = document.querySelectorAll('[data-mainproductcarousel]');
    var productNavCarousel = document.querySelectorAll('[data-productNavCarousel]');

    mainCarousel.forEach((mainCarousel) => new Flickity(mainCarousel, options));
    productNavCarousel.forEach((productNavCarousel) => new Flickity(productNavCarousel, navOptions));
  }

  //IMAGE & TEXT SLIDER
  const contentParent = document.querySelectorAll('.content-slider');

  const contentOptions = {
    accessibility: true,
    wrapAround: true,
    autoPlay: false,
    prevNextButtons: false,
    pageDots: false,
    imagesLoaded: true,
    fade: true,
  };

  contentParent.forEach((parent) => {
    let contentFlickty = new Flickity(parent, contentOptions);
    const prevBtns = parent.querySelectorAll('.content-previous');
    const nextBtns = parent.querySelectorAll('.content-next');

    prevBtns.forEach((prevBtn) => {
      prevBtn.addEventListener('click', function () {
        contentFlickty.previous();
      });
    });
    nextBtns.forEach((nextBtn) => {
      nextBtn.addEventListener('click', function () {
        contentFlickty.next();
      });
    });

    var carouselStatus = parent.querySelectorAll('.carousel-status');

    function updateStatus() {
      var slideNumber = contentFlickty.selectedIndex + 1;
      carouselStatus.forEach((carouselStatus) => {
        if (slideNumber < 10 && contentFlickty.slides.length < 10) {
          carouselStatus.textContent = '0' + slideNumber + '/' + '0' + contentFlickty.slides.length;
        } else if (slideNumber < 10) {
          carouselStatus.textContent = '0' + slideNumber + '/' + contentFlickty.slides.length;
        } else {
          carouselStatus.textContent = slideNumber + '/' + contentFlickty.slides.length;
        }
      });
    }
    updateStatus();

    contentFlickty.on('select', updateStatus);
  });

  const timelineSlider = document.querySelector('.timeline-slider');
  const timelineParent = document.querySelector('.timeline-block');

  if (timelineParent) {
    const timelineOptions = {
      accessibility: true,
      wrapAround: false,
      autoPlay: false,
      prevNextButtons: false,
      pageDots: false,
      imagesLoaded: true,
      cellAlign: 'left',
    };

    let timelineFlickty = new Flickity(timelineSlider, timelineOptions);

    var buttons = document.querySelectorAll('.timeline-year');

    const prevBtns = timelineParent.querySelectorAll('.timeline-previous');
    const nextBtns = timelineParent.querySelectorAll('.timeline-next');

    prevBtns.forEach((prevBtn) => {
      prevBtn.addEventListener('click', function () {
        timelineFlickty.previous();
      });
    });
    nextBtns.forEach((nextBtn) => {
      nextBtn.addEventListener('click', function () {
        timelineFlickty.next();
      });
    });

    timelineFlickty.on('select', function (index) {
      var currentSlide = timelineFlickty.cells[index].element;
      var dataYear = currentSlide.getAttribute('data-year');

      buttons.forEach((button) => {
        button.classList.remove('active');

        if (button.textContent === dataYear) {
          button.classList.add('active');
        }
      });

      prevBtns.forEach((prevBtn) => {
        if (timelineFlickty.selectedIndex == 0) {
          prevBtn.classList.add('opacity-40');
          prevBtn.classList.remove('hover:bg-orange');
          prevBtn.classList.remove('hover:border-orange');
          prevBtn.disabled = true;
        } else {
          prevBtn.classList.remove('opacity-40');
          prevBtn.classList.add('hover:bg-orange');
          prevBtn.classList.add('hover:border-orange');
          prevBtn.disabled = false;
        }
      });
      nextBtns.forEach((nextBtn) => {
        if (timelineFlickty.selectedIndex == timelineFlickty.slides.length - 1) {
          nextBtn.classList.add('opacity-40');
          nextBtn.classList.remove('hover:bg-orange');
          nextBtn.classList.remove('hover:border-orange');
          nextBtn.disabled = true;
        } else {
          nextBtn.classList.remove('opacity-40');
          nextBtn.classList.add('hover:bg-orange');
          nextBtn.classList.add('hover:border-orange');
          nextBtn.disabled = false;
        }
      });
    });

    buttons.forEach((button) => {
      button.addEventListener('click', function (event) {
        if (event.target === button) {
          targetYear = button.dataset.target;
          let firstTargetFound = false;

          timelineFlickty.cells.forEach((slide, index) => {
            let slideYear = slide.element.getAttribute('data-year');

            if (slideYear == targetYear && !firstTargetFound) {
              timelineFlickty.select(index);
              firstTargetFound = true;
              return;
            }
          });
        }
      });
    });
  }

  if (document.querySelector('.relatedproduct-carousel')) {
    var options = {
      accessibility: true,
      prevNextButtons: true,
      pageDots: false,
      cellAlign: 'left',
      wrapAround: true,
      contain: true,
      imagesLoaded: true,
      lazyLoad: false,
      cellSelector: '.carousel-cell',
    };

    var relatedCarousel = document.querySelectorAll('[data-relatedcarousel]');
    var shortCarousel = document.querySelectorAll('[data-shortrelatedcarousel]');

    if (relatedCarousel) {
      console.log('Carousel found');
      relatedCarousel.forEach((relatedCarousel) => new Flickity(relatedCarousel, options));
    }

    if (shortCarousel) {
      options = {
        accessibility: true,
        prevNextButtons: false,
        pageDots: false,
        cellAlign: 'left',
        wrapAround: true,
        contain: true,
        imagesLoaded: true,
        watchCSS: true,
        cellSelector: '.carousel-cell',
      };
      shortCarousel.forEach((shortCarousel) => new Flickity(shortCarousel, options));
    }
  }

  if (document.querySelectorAll('.quantity-number-input')) {
    const quantityInputs = document.querySelectorAll('.quantity-number-input');
    const updateTotalsButton = document.querySelector('#update-totals-button');
    let changeTimer; //timer identifier
    let changeInterval = 1000; //time in ms (5 seconds)

    quantityInputs.forEach((input) => {
      input.addEventListener('change', () => {
        clearTimeout(changeTimer);
        if (input.value) {
          changeTimer = setTimeout(updateTotals, changeInterval);
        } else {
        }
      });
    });

    function updateTotals() {
      updateTotalsButton.click();
    }
  }

  // How long you want the animation to take, in ms
  const animationDuration = 2000;
  // Calculate how long each ‘frame’ should last if we want to update the animation 60 times per second
  const frameDuration = 1000 / 60;
  // Use that to calculate how many frames we need to complete the animation
  const totalFrames = Math.round(animationDuration / frameDuration);
  // An ease-out function that slows the count as it progresses
  const easeOutQuad = (t) => t * (2 - t);

  // The animation function, which takes an Element
  const animateCountUp = (el) => {
    let frame = 0;
    const countTo = parseInt(el.innerHTML, 10);
    // Start the animation running 60 times per second
    const counter = setInterval(() => {
      frame++;
      // Calculate our progress as a value between 0 and 1
      // Pass that value to our easing function to get our
      // progress on a curve
      const progress = easeOutQuad(frame / totalFrames);
      // Use the progress value to calculate the current count
      const currentCount = Math.round(countTo * progress);

      // If the current count has changed, update the element
      if (parseInt(el.innerHTML, 10) !== currentCount) {
        el.innerHTML = currentCount;
      }

      // If we’ve reached our last frame, stop the animation
      if (frame === totalFrames) {
        clearInterval(counter);
      }
    }, frameDuration);
  };

  // Run the animation on all elements with a class of ‘countup’
  const runAnimations = () => {
    const countupEls = document.querySelectorAll('.count-num');
    countupEls.forEach(animateCountUp);
    const dottedBorder = document.querySelectorAll('.dotted-border');
    dottedBorder.forEach((circle) => {
      animate(circle, { transform: 'rotate(90deg)' }, { duration: 2 });
    });
  };

  const banner = document.querySelector('.count-banner .count-num');

  inView(banner, () => {
    runAnimations();
  });
};

if (document.readyState !== 'loading') {
  init();
} else {
  document.addEventListener('DOMContentLoaded', init);
}
